import * as React from 'react';
import { connect } from 'react-redux';
import { productCompareModalSelector } from '../App/selectors';
import { addProductCompareModal } from '../App/actions';
import { push } from 'react-router-redux';
import { __r } from 'react-i18n';
import { CompareService } from 'eshop-defaults';
import CompareModalWindow from '../../components/Comparison/CompareModalWindow';

interface Props {
  dispatch: any;
  productCompareModal: any;
}

function CompareModalWindowContainer({ dispatch, productCompareModal }: Props) {
  const handleOnClose = () => {
    dispatch(addProductCompareModal(null));
  };

  const handleOnReset = () => {
    const compareService = new CompareService();
    compareService.removeAll();
    if (productCompareModal?.productId) {
      compareService.addProductToCompare(productCompareModal.productId);
    }
    dispatch(addProductCompareModal(null));
  };

  const handleOnRedirect = () => {
    dispatch(push(__r('routes:porovnanie', '/porovnanie')));
    dispatch(addProductCompareModal(null));
  };

  return (
    <CompareModalWindow
      modalType={productCompareModal?.modalType}
      onClose={handleOnClose}
      onReset={handleOnReset}
      onRedirect={handleOnRedirect}
    />
  );
}

const mapStateToProps = state => {
  return {
    lang: state.general.lang,
    productCompareModal: productCompareModalSelector(state),
  };
};

export default connect(mapStateToProps)(CompareModalWindowContainer);
